import "./wwfconfigs";

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';

import store from './store/index';
import { mapState } from 'vuex';

// Libraries
import VeeValidate from 'vee-validate'; // Validations library http://vee-validate.logaretm.com/
import vueConfig from 'vue-config';
import vueFilter from 'vue-filter';
import resource from 'vue-resource'; // Vue resource library https://github.com/pagekit/vue-resource/blob/develop/docs/http.md
import VueFormWizard from 'vue-form-wizard';
import printJS from 'print-js';
import VueYouTubeEmbed from 'vue-youtube-embed'; // https://github.com/kaorun343/vue-youtube-embed
import VueCookie from 'vue-cookie';
import firebase from 'firebase/app';
import 'firebase/auth';

// Components
import ContactUs from './components/ContactUs.vue';
import LoyaltyForm from './components/LoyaltyForm.vue';
import NewsletterSignup from './components/NewsletterSignup.vue';
import SocialMedia from './components/SocialMedia.vue'
import MyPetitionForm from './components/PetitionForm.vue';
import MyPetitionEpbc from './components/PetitionEpbc.vue';
import MyTwitchForm from './components/TwitchForm';
import WwfMenuCountryListBtn from './components/WwfMenuCountryListBtn.vue';
import WwfRichmondFcForm from './components/WwfRichmondFcForm.vue';
import YoutubeVideo from './components/YoutubeVideo.vue';
import ThankYouDonation from './components/ThankYouDonation.vue';
import ThankYouMultiAction from './components/ThankYouMultiAction.vue';
import RichContentDisplay from './components/utils/RichContentDisplay.vue';

// Forms
import Bequest from './components/forms/Bequest.vue';
import EdoForm from './components/forms/Edo.vue';
import EdoPopup from './components/forms/EdoPopup.vue';
import EdoVideoUpload from './components/forms/EdoVideoUpload.vue';
import PartnershipsForm from './components/forms/PartnershipsForm.vue';
import Petition from './components/forms/Petition.vue';
import Newsletter from './components/forms/Newsletter.vue';

// Earth Hour
import EarthhourRegistration from './components/earth-hour/EarthhourRegistration.vue';
import EarthhourCompetition from './components/earth-hour/EarthhourCompetition.vue';
import EarthhourLogoWall from './components/earth-hour/EarthhourLogoWall.vue';
import EarthhourPopup from './components/earth-hour/EarthhourPopup.vue';

// Components - Search
import SearchAutocomplete from './components/search/SearchAutocomplete.vue';
import SearchResult from './components/search/SearchResult.vue';

// Components - Donation related
import FormProduct from './components/product/FormProduct.vue';
import DollarHandleWidget from './components/product/DollarHandleWidget.vue';
import UpdateDetails from './components/donor/UpdateDetails.vue';
import DonateWidget from './components/product/DonateWidget.vue';
import DonateRgForm from './components/product/DonateRgForm.vue';
import DonationTitle from './components/product/DonateTitle.vue';
import ProductSelector from './components/product/ProductSelector.vue';
import DonationListenner from './components/product/DonationListenner.vue';

// RA
import Donate from './components/donation/Donate.vue';
import LeafRelief from './components/leaf-relief/LeafRelief.vue';
import ImpactProject from './components/impact-project/ImpactProject.vue';
import ImpactProjectHeader from './components/impact-project/ImpactProjectHeader.vue';
import EcommerceFilter from './components/ecommerce/filter/EcommerceFilter.vue';
import EcommerceCarousel from './components/ecommerce/EcommerceCarousel.vue';
import EcommerceSlider from './components/ecommerce/EcommerceSlider.vue';
import ImpactProjectMilestones from './components/impact-project/ImpactProjectMilestones.vue';
import ImpactDonateWrapper from './components/impact-project/ImpactDonateWrapper.vue';
import RaHubSolutions from './components/hub/RaHubSolutions.vue';
import RaHubCarousel from './components/hub/RaHubCarousel.vue';

// CSS
import './styles/global.css';
import './styles/unknown.css';
import './styles/form.css';
import './styles/donation-form.css';
import './styles/thankyou-popup.css';
import './styles/popup-petition-message.css';
import './styles/vdp-datepicker.css';
import './styles/autocomplete.css';
import './styles/search-bar.css';
import './styles/earth-hour-popup.css';
import './styles/edo-supporter-messages.css';
import './styles/donation.css';
import './styles/donation-carousel.css';
import './styles/leaf-relief.css';


// Website related CSS
import './styles/carousel.css';

// Helpers
import {
  getNameByDonationType,
  isEditMode,
  getNameByPaymentType
} from './helpers';

import gtm from "./utils/gtm";

Vue.use(resource);
Vue.use(VueYouTubeEmbed);
Vue.use(VeeValidate, { events: '' });
Vue.use(vueConfig, wwfconfigs);
Vue.use(VueFormWizard); // Vue form wizard register
Vue.use(vueFilter);
Vue.use(VueCookie);

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent)
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent)
  },
});

const firebaseConfig = {
  apiKey: wwfconfigs.FIREBASE_API_KEY,
  projectId: wwfconfigs.FIREBASE_PROJECT_ID,
};
firebase.initializeApp(firebaseConfig);

Vue.config.productionTip = false;

const vm = new Vue({
  el: '#bodyapp',
  store: store,
  data() {
    return {
      revealDonation: null,
      revealPetition: null,
      revealPetitionMessage: null,
      revealEarthHour: null,
      revealCustomContent: null,
      revealLetter: null,
      isProcessing: false
    };
  },
  computed: mapState({
    donation: state => state.donation.donation,
    product: state => state.product.product,
    update_details: state => state.updates.update_details,
    thankYouPopup: state => state.popup.content,
    openDonationPopup: state => state.popup.openDonationPopup,
    openPetitionPopup: state => state.popup.openPetitionPopup,
    openPetitionMessagePopup: state => state.popup.openPetitionMessagePopup,
    openEarthHourPopup: state => state.popup.openEarthHourPopup,
    openCustomContentPopup: state => state.popup.openCustomContentPopup,
  }),
  created() {
    this.$store.dispatch('login');
  },
  mounted() {
    // Don't mount the reveal if edit mode
    if (!isEditMode()) {
      this.revealDonation = new Foundation.Reveal($('#reveal-dialog-donation'), { animationIn: 'fade-in-up fast', });
      this.revealPetition = new Foundation.Reveal($('#reveal-dialog-petition'), { animationIn: 'fade-in-up fast', });
      this.revealPetitionMessage = new Foundation.Reveal($('#reveal-popup-petition-message'), { animationIn: 'fade-in-up fast', additionalOverlayClasses: 'popup-no-scroll' });
      this.revealEarthHour = new Foundation.Reveal($('#reveal-dialog'), { animationIn: 'fade-in-up fast', additionalOverlayClasses: 'popup-black-background' });
      this.revealCustomContent = new Foundation.Reveal($('#reveal-popup-custom-content'), { animationIn: 'fade-in-up fast' });
    }
  },
  watch: {
    openDonationPopup: function (val) {
      if (val === true && this.revealDonation) {
        const payload = {
          amount: this.donation.amount,
          donationtype: this.donation.type,
          payementType: this.donation.payementType,
          transactionid: this.donation.transactionid,
          productname: this.product.productname,
          producttype: this.product.producttype,
          productid: this.product.id,
          postcode: this.donation.billing.postcode,
          firstname: this.donation.firstname,
          lastname: this.donation.lastname,
          certificateurl: this.product.certificateurl,
          wildcardurl: (this.donation.wildcard && this.donation.wildcard.pdf) ? this.donation.wildcard.pdf : null,
          showCertificate: this.product.producttype === 'adoption',
          isMonthly: this.donation.type === 'Regular',
          showWildcard: this.product.producttype === 'wildcard'
        };

        // Send data to Google Tag Manager
        gtm.pushPurchase(
          payload.transactionid,
          payload.productname,
          payload.productid,
          payload.producttype,
          getNameByDonationType(payload.donationtype),
          payload.amount,
          payload.postcode,
          getNameByPaymentType(payload.payementType));

        // Set the data to display in the popup
        this.thankYouPopup.firstname = payload.firstname;
        this.thankYouPopup.lastname = payload.lastname;
        this.thankYouPopup.amount = payload.amount;
        this.thankYouPopup.showCertificate = payload.showCertificate;
        this.thankYouPopup.certificateurl = payload.certificateurl;
        this.thankYouPopup.isMonthly = payload.isMonthly;
        this.thankYouPopup.showWildcard = payload.showWildcard;

        this.revealDonation.open();
        setTimeout(() => {
          this.thankYouPopup.isOpen = true;
          this.$store.commit('openDonationPopup', false);
        }, 200);

        if (this.$refs.formproduct && payload.paymenttype != "wwf_paypal") {
          this.$refs.formproduct.reset();
        }
      }
    },
    openPetitionPopup: function (val) {
      if (val === true && this.revealPetition) {
        this.revealPetition.open();
        setTimeout(() => {
          this.thankYouPopup.isOpen = true;
          this.$store.commit('openPetitionPopup', false);
        }, 200);
      }
    },
    openPetitionMessagePopup: function (val) {
      if (val === true && this.revealPetitionMessage) {
        this.revealPetitionMessage.open();
        setTimeout(() => {
          this.thankYouPopup.isOpen = true;
          this.$store.commit('openPetitionMessagePopup', false);
        }, 200);
      }
    },
    openEarthHourPopup: function (val) {
      if (val === true && this.revealEarthHour) {
        this.revealEarthHour.open();
        setTimeout(() => {
          this.thankYouPopup.isOpen = true;
          this.$store.commit('openEarthHourPopup', false);
        }, 200);
      }
    },
    openCustomContentPopup: function (val) {
      if (val === true && this.revealCustomContent) {
        this.revealCustomContent.open();
        setTimeout(() => {
          this.thankYouPopup.isOpen = true;
          this.$store.commit('openCustomContentPopup', false);
        }, 200);
      }
    },
  },
  methods: {
    openThankYouPopup: function (e) {
      [this.thankYouPopup.firstname, this.thankYouPopup.lastname, this.thankYouPopup.amount, this.thankYouPopup.showCertificate, this.thankYouPopup.certificateurl, this.thankYouPopup.isMonthly, this.thankYouPopup.showWildcard, this.thankYouPopup.wildcardurl] = e;
      if (this.revealDonation) {
        this.revealDonation.open();
        setTimeout(() => this.thankYouPopup.isOpen = true, 200);
      }
    },
    openThankYouPopupPetition: function (e) {
      [this.thankYouPopup.title, this.thankYouPopup.message, this.thankYouPopup.shareButton, this.thankYouPopup.recommendedReading, this.thankYouPopup.component, this.thankYouPopup.componentparams] = e;
      this.revealPetition.open();
      setTimeout(() => this.thankYouPopup.isOpen = true, 200);
    },
    thankyou: function (amount, donationtype, transactionid, productname, postcode, firstname, lastname, producttype, certificateurl, productid, paymenttype, wildcardurl) {
      gtm.pushPurchase(transactionid, productname, productid, producttype, getNameByDonationType(donationtype), amount, postcode, getNameByPaymentType(paymenttype))
      this.openThankYouPopup([firstname, lastname, amount, producttype == 'adoption', certificateurl, donationtype == 'Regular', producttype == 'wildcard', wildcardurl]);
      if (this.$refs.formproduct && paymenttype != "wwf_paypal") {
        this.$refs.formproduct.reset();
      }
    },
    confirmtransaction: function (transactionid) {
      console.log('confirmtransaction::transactionid', transactionid);
      this.thankyou(this.donation.amount, this.donation.type, transactionid, this.product.productname, this.donation.billing.postcode, this.donation.firstname, this.donation.lastname, this.product.producttype, this.product.certificateurl, this.product.id, this.donation.payementType, (this.donation.wildcard && this.donation.wildcard.pdf) ? this.donation.wildcard.pdf : null)
    },
    confirmtransactionupdatedetail: function (maskedcard, name, date, type) {
      if (this.$refs.updatedetail) {
        this.$refs.updatedetail.confirmtransaction(maskedcard, name, date, type);
      }
    },
    retryupdatedetail: function retry() {
      if (this.$refs.updatedetail) {
        this.$refs.updatedetail.retry();
      }
    },
    retry: function () {
      if (this.$refs.formproduct) {
        this.$refs.formproduct.retry();
      }
    },
    disablesteps: function () {
      if (this.$refs.formproduct) {
        this.$refs.formproduct.disablesteps();
      }
    },
    printCertificate: function () {
      printJS({ printable: 'certificate', type: 'html', targetStyles: ['*'] })
    },
    printCertificateNew() {
      console.log('This is a print');
      printJS({ printable: 'thank-you-certificate', type: 'html', targetStyles: ['*'] })
    }
  },
  components: {
    DonateRgForm,
    YoutubeVideo,
    NewsletterSignup,
    MyPetitionForm,
    MyPetitionEpbc,
    MyTwitchForm,
    ContactUs,
    LoyaltyForm,
    WwfRichmondFcForm,
    WwfMenuCountryListBtn,
    PartnershipsForm,
    FormProduct,
    DollarHandleWidget,
    UpdateDetails,
    DonateWidget,
    Bequest,
    SearchAutocomplete,
    SearchResult,
    SocialMedia,
    ThankYouDonation,
    ThankYouMultiAction,
    DonationTitle,
    EarthhourRegistration,
    EarthhourCompetition,
    EdoForm,
    EdoPopup,
    EdoVideoUpload,
    EarthhourLogoWall,
    EarthhourPopup,
    Petition,
    ProductSelector,
    DonationListenner,
    RichContentDisplay,
    Donate,
    LeafRelief,
    ImpactProject,
    ImpactProjectHeader,
    EcommerceFilter,
    EcommerceCarousel,
    EcommerceSlider,
    ImpactProjectMilestones,
    ImpactDonateWrapper,
    RaHubSolutions,
    RaHubCarousel,
    Newsletter
  }
});

window.app = vm;



// WEBPACK FOOTER //
// ./src/wwf.main.js